<script setup>
  const props = defineProps({
    spotMessage: {
      type: String,
      default: null
    }
  });
</script>

<template>
  <div v-if="props.spotMessage" class="jwx-toolbar-header__message">
    <p class="jwx-toolbar-header__message-label">Special Note:</p>
    <p v-html="props.spotMessage" class="jwx-toolbar-header__message-text"></p>
  </div>
</template>